const NEWLINE = '\r\n';
const BOOKING_PROVIDER_STRING = 'B:';
const HOTEL = 'hotel';

export default {
	NEWLINE,
	BOOKING_PROVIDER_STRING,
	HOTEL,
};
